import { ChangeEvent, forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import TextareaAutosize from 'react-textarea-autosize';

import { inputStyle } from './styles.ts';

import { InputContent } from '@/components/common/InputContent/InputContent.tsx';

const BIO_MAX_LENGTH = 140;

type BioTextareaProps = {
  about_me: string;
  updateFields: (fields: Partial<{ about_me: string }>) => void;
  isRegistration?: boolean;
};

export const BioTextarea = forwardRef<HTMLTextAreaElement, BioTextareaProps>(
  ({ about_me, updateFields }, ref) => {
    const { t } = useTranslation();

    const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
      updateFields({ about_me: e.target.value });
    };

    return (
      <InputContent
        title={t('bio_section').toUpperCase()}
        styleTitle={{ fontWeight: 510, fontSize: 12, color: '#787878' }}
      >
        <TextareaAutosize
          ref={ref}
          placeholder={t('bio_placeholder')}
          minRows={3}
          maxRows={7}
          value={about_me}
          onChange={handleChange}
          maxLength={BIO_MAX_LENGTH}
          style={{
            ...inputStyle,
            resize: 'none',
            boxSizing: 'border-box'
          }}
        />
        <div
          style={{
            marginTop: '5px',
            marginRight: '12px',
            marginLeft: '12px',
            fontSize: '12px',
            color: '#787878',
            display: 'flex',
            justifyContent: 'space-between',
            fontWeight: 510
          }}
        >
          <span>{t('bio_section_example')}</span>
          <span>
            {about_me.length}/{BIO_MAX_LENGTH}
          </span>
        </div>
      </InputContent>
    );
  }
);

BioTextarea.displayName = 'BioTextarea';
